import { ReactNode, createContext, useContext } from 'react';

import { useCreateStockAdjustment } from './hook';

type CreateStockAdjustmentContextType = ReturnType<
    typeof useCreateStockAdjustment
>;

const CreateStockAdjustmentContext =
    createContext<CreateStockAdjustmentContextType | null>(null);

export const CreateStockAdjustmentProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const contextValue = useCreateStockAdjustment();

    return (
        <CreateStockAdjustmentContext.Provider value={contextValue}>
            {children}
        </CreateStockAdjustmentContext.Provider>
    );
};

export const useCreateStockAdjustmentContext = () => {
    const context = useContext(CreateStockAdjustmentContext);
    if (!context) {
        throw new Error(
            'useCreateStockAdjustmentContext must be used within a CreateStockAdjustmentProvider',
        );
    }
    return context;
};
